import { cn } from 'utils/styles';

export type LineBreakProps = {
  testId?: string;
  breakBehavior: 'Desktop Only' | 'Mobile Only' | 'All';
};

const LineBreak = ({ testId, breakBehavior }: LineBreakProps) => {
  return (
    <span>
      {' '}
      <br
        className={cn({
          'md:hidden': breakBehavior === 'Mobile Only',
          'hidden md:block': breakBehavior === 'Desktop Only',
        })}
        data-testid={testId}
        data-break-behavior={breakBehavior}
      />
    </span>
  );
};

export default LineBreak;
